import { useState } from 'react'
import { Chip, CircularProgress, ListItemText, Menu, MenuItem, Tooltip, Typography } from '@mui/material'
import { fetchRelatedContacts } from './api.js'
import { relatedChipEntries } from './relatedContacts.js'

// The "related" chip (related contacts, 2026-10-20), in the Queue row and on
// the contact header next to the intent chip. A click lists the contact's
// related contacts with their status and relation; each one opens that
// contact. members: already loaded (the contact header has them); else they
// are fetched on the first click (GET /api/conversations/:id/related, the
// viewer's own visibility).
export default function RelatedChip({ conversationId, members = null, onOpen, size = 'small', sx }) {
  const [anchor, setAnchor] = useState(null)
  const [loaded, setLoaded] = useState(members)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const list = relatedChipEntries(members ?? loaded ?? [])

  async function onClick(e) {
    e.stopPropagation()
    setAnchor(e.currentTarget)
    if (members || loaded) return
    setLoading(true); setError(null)
    try {
      setLoaded((await fetchRelatedContacts(conversationId)).members ?? [])
    } catch (err) {
      setError(err.message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <Tooltip title="This customer has other contacts about the same issue. Click to see them.">
        <Chip size={size} variant="outlined" label="related ▾" data-testid="related-chip" clickable
          onClick={onClick} onMouseDown={(e) => e.stopPropagation()} sx={sx} />
      </Tooltip>
      <Menu anchorEl={anchor} open={Boolean(anchor)} onClose={(e) => { e?.stopPropagation?.(); setAnchor(null) }} onClick={(e) => e.stopPropagation()}>
        {loading && <MenuItem disabled><CircularProgress size={14} /></MenuItem>}
        {error && <MenuItem disabled><Typography variant="caption" color="error">{error}</Typography></MenuItem>}
        {!loading && !error && list.length === 0 && <MenuItem disabled>No related contacts you can open</MenuItem>}
        {list.map((m) => (
          <MenuItem key={m.id} data-testid="related-chip-item" onClick={() => { setAnchor(null); onOpen?.(m.id, m.convNumber) }}>
            <ListItemText primary={`#${m.convNumber ?? '?'}`} secondary={`${m.status}, ${m.relation}`} />
          </MenuItem>
        ))}
      </Menu>
    </>
  )
}
